import { GameOption } from "../../game-state/game-state.type";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { retrieveUrl } from "../../game-state/games.functions";

export const OptionImage = ({ option }: { option: GameOption }) => {
  const storage = useAppSelector((state) => state.storageState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(retrieveUrl(`data/${option.imageUrl}`));
  }, [option, dispatch]);

  const resolvedUrl = storage[`data/${option.imageUrl}`];

  if (resolvedUrl) {
    return (
      <img
        className="object-cover h-32 sm:h-40 lg:h-60 w-full"
        src={storage[`data/${option.imageUrl}`]}
        alt={option.id}
      />
    );
  } else {
    return (
      <div className="h-32 sm:h-40 lg:h-60 w-full text-blue-500 flex items-center justify-center">
        <i className="fa fa-spin fa-circle-notch fa-3x" />
      </div>
    );
  }
};
